import Profile from 'components/pages/DemographicsSettings/DemographicsSettings';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('profile');
export default buildPage(Profile, {
  noMarginBottomMobile: true,
  requiresAuthentication: true,
  metaData: {
    title: 'Profile',
    description: 'Your profile',
  },
});
